import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MtUser } from "server/models"
import { deepCopy, StateType } from "client/utils"
import { mtUsersRoute } from "client/parts/routes"
import {
    StoreType,
    UserList,
    UserFilters,

    LoadAllUsers,
    LoadAllUserAccounts,
    ChangeUserStatus,
    SortUsers,

    setUserList,
    setUserIds,
    setUserSort,
    setUserFilters,
    setUserAccountList,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    ChangeStatus,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"


const List = () => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const userIds = useSelector((state: StoreType) => state.user.userIds)
    const sortColumn = useSelector((state: StoreType) => state.user.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.user.sortOrder)
    const filters = useSelector((state: StoreType) => state.user.filters)
    const reloadList = useSelector((state: StoreType) => state.user.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        const promiseArray = [
            LoadAllUsers().then((res) => {
                dispatch(setUserList(res))
            }),
            LoadAllUserAccounts().then((res) => {
                dispatch(setUserAccountList(res))
            }),
        ]
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        dispatch(setUserIds(sortedIds))
    }, [userList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setUserSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setUserFilters(newFilters))
    }

    const onStatusChange: ChangeStatus = (user: MtUser, callback) => {
        ChangeUserStatus(user).then((status) => {
            callback(() => {
                const userListCopy: UserList = deepCopy(userList)
                userListCopy[user.id] = {
                    ...userListCopy[user.id],
                    status,
                }
                dispatch(setUserList(userListCopy))
            })
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.users}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <UserSearch
                        id="userList"
                        rightOffset
                        filters={filters}
                        onFilter={onFilter}
                    />
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({ url: `${mtUsersRoute}/${EDIT}/0` }))}
                    >
                        {lang.add}
                    </Button>
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="md"
                    showPagination
                    onSort={onSort}
                    onStatusChange={onStatusChange}
                />
            </PageContent>
        </Container>
    )
}
export default List
